<template>
  <div class="side-bar">
    <div class="header">
      <q-img
        :src="setLogoLorni(userData.company_id)"
        style="max-width: 123px"
      />
    </div>
    <div class="actions items-center">
      <CardPerson
        :image="userData.avatar_location"
        :userData="userData"
        :company="userData.company_name"
        :progress="84"
        :level="18"
        :name="nameUser"
        :typeUser="userData.role"
      />
      <div class="menu-list justify-center q-mt-xl">
        <ListMenu
          :menuOptions="menuOptions"
          :chatData="chat"
        >
          <template v-slot:moreOptions>
            <!-- TODO: corrigir verificacao de analitico e menu adm-->
            <DropListMenu
              v-if="admPermissions"
              :iconName="Company"
              name="Administração"
              :adminMenu="adminMenu"
            />
            <DropListMenu
              v-if="analyticPermissions"
              :iconName="Data"
              name="Analítico"
              :adminMenu="dataMenu"
            />
            <div class="item">
              <q-item
                clickable
                dense
                @click="logout"
                exact
                v-ripple
                class="text-white flex items-center"
                active-class="bg-white text-black"
              >
                <div class="avatar-menu q-pl-xs">
                  <q-img
                    width="100%"
                    src="@/assets/icons/logout.svg"
                  />
                </div>
                <q-item-section>Sair</q-item-section>
              </q-item>
            </div>
          </template>
        </ListMenu>
      </div>
    </div>
  </div>
</template>

<script>
//----ICONS
import Company from "@/assets/icons/menu/Company.vue";
import Data from "@/assets/icons/menu/Data.vue";
import Groups from "@/assets/icons/menu/Groups.vue";
import Users from "@/assets/icons/menu/Users.vue";
import Dashboard from "@/assets/icons/menu/Dashboard.vue";
import Reports from "@/assets/icons/menu/Reports.vue";
import History from "@/assets/icons/menu/History.vue";

//----COMPONENTS
import CardPerson from "@/components/sidebar/cards/CardPerson.vue";
import StoreBtn from "@/components/sidebar/buttons/StoreBtn.vue";
import ListMenu from "@/components/sidebar/listItems/ListMenu.vue";
import DropListMenu from "@/components/sidebar/listItems/DropListMenu.vue";

//----SERVICES
import ChatServices from "@/services/ChatServices";
import { HttpTransportType } from "@aspnet/signalr";
import UserServices from "@/services/UserServices";

//----UTILS
import CanUserAccessClass from "@/utils/CanUserAccessClass";
import Socket from "@/utils/Socket";

//----VUEJS
import { ref, onMounted, reactive, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import lorniLogo from "@/assets/logo/logo_lorni_white.svg";
import dasaLogo from "@/assets/logo/dasa.svg";
import liveloLogo from "@/assets/logo/livelo.svg";
import cnpLogo from "@/assets/logo/logo_cnp_seguradora.svg";
import comGas from "@/assets/logo/logo-comgas.svg";
import bancoMercantil from "@/assets/logo/logo-bancoMercantil.svg";
import senaiLogo from "@/assets/logo/logo-senai.svg";
import sesiLogo from "@/assets/logo/logo-sesi.svg";
import rexonLogo from "@/assets/logo/logo-rexon.svg";

export default {
  name: "SideBar",
  components: {
    CardPerson,
    StoreBtn,
    ListMenu,
    DropListMenu,
  },

  setup() {
    //----VUEJS
    const route = useRoute();
    const store = useStore();

    //----SERVICES
    const _socket = new Socket();
    const _chatServices = new ChatServices();
    const canUserAccessClass = new CanUserAccessClass();
    const userServices = new UserServices();

    const admPermissions = computed(() => {
      return (
        userData.master === 1 ||
        canUserAccessClass.canUserAccessWithPermissions(
          [
            "menu-admin",
            "users-view",
            "groups-view",
            "company-humor-view",
            "company-configuration",
          ],
          false,
        )
      );
    });

    const analyticPermissions = computed(() => {
      return (
        userData.value.master == 1 ||
        canUserAccessClass.canUserAccessWithPermissions(
          [
            "analytic",
            "analytic-reports",
            "analytic-reports-courses",
            "analytic-reports-posts",
            "analytic-reports-users",
            "analytic-reports-humor",
            "analytic-reports-wikis",
            "analytic-reports-survey",
            "analytic-reports-interaction",
            "analytic-history",
            "dashboard",
            "analytic-history-courses",
            "analytic-history-wikis",
            "analytic-history-posts",
            "analytic-history-users",
            "analytic-history-lightning",
            "analytic-history-humor",
          ],
          false,
        )
      );
    });

    //----CONSTANTS
    const refAudioChat = ref(null);
    const userData = ref(store.state.userdata);
    const adminMenu = ref([
      isUserMaster()
        ? {
            name: "Empresa",
            icon: Company,
            route: "/company",
            routeName: "company",
            permission: isUserMaster(),
          }
        : {
            name: "Empresa",
            icon: Company,
            route: "/company-configuration",
            routeName: "company-configuration",
            permission: validateActionsPage("company-configuration"),
          },
      {
        name: "Grupos",
        icon: Groups,
        route: "/groups",
        routeName: "groups",
        permission: validateActionsPage("groups-view"),
      },
      {
        name: "Usuários",
        icon: Users,
        route: "/users",
        routeName: "users",
        permission:
          validateActionsPage("users-view") || validateActionsPage("users"),
      },
    ]);
    const dataMenu = ref([
      {
        name: "Relatórios",
        icon: Reports,
        route: "/reports",
        routeName: "reports",
        permission: canUserAccessClass.canUserAccessWithPermissions(
          [
            "analytic-reports",
            "analytic-reports-courses",
            "analytic-reports-posts",
            "analytic-reports-users",
            "analytic-reports-humor",
            "analytic-reports-wikis",
            "analytic-reports-interaction",
            "analytic-reports-survey",
            "analytic-reports-lightning",
          ],
          false,
        ),
      },
      {
        name: "Histórico",
        icon: History,
        route: "/history",
        routeName: "history",
        permission: canUserAccessClass.canUserAccessWithPermissions(
          [
            "analytic-history",
            "analytic-history-wikis",
            "analytic-history-posts",
            "analytic-history-courses",
            "analytic-history-users",
            "analytic-history-lightning",
            "analytic-history-humor",
          ],
          false,
        ),
      },
      {
        name: "Dashboard",
        icon: Dashboard,
        route: "/dashboard",
        routeName: "dashboard",
        permission: validateActionsPage("dashboard"),
        parent_id: 0,
      },
    ]);

    //----VARIABLES
    let menuOptions = ref([]);
    let showAdm = ref(false);
    let chat = reactive({
      hasNewMessage: false,
      quantity: 0,
    });

    function validateActionsPage(routeName) {
      if (!canUserAccessClass.canUserAccess(routeName, false)) {
        return false;
      }
      return true;
    }

    function isUserMaster() {
      let MASTER_ID = 1;
      return userData.value.master == MASTER_ID;
    }

    function _getMenuOptions() {
      menuOptions.value = JSON.parse(localStorage.getItem("vuex")).menu;
    }

    async function logout() {
      await userServices.logout().then(() => {
        _socket.disconnect();
        localStorage.clear();
        store.commit("setUserData", null);
      });
      window.location = "/";
    }

    function toogleAdm() {
      showAdm.value = !showAdm.value;
    }

    function _listingNewMessages() {
      store.state.socket.connection.on(
        "ReceiveMessage",
        (conversationId, message) => {
          if (message.user_id != userData.value.id) {
            if (route.name != "chat") {
              let lastMessage = message.name + ": " + message.message;
              chat.hasNewMessage = true;
              chat.quantity = chat.quantity + 1;
              _changeTitleOfPage(lastMessage);

              store.dispatch("AddMessages", {
                conversationId: conversationId,
                message: message,
              });
            }
          }
        },
      );
    }

    function setLogoLorni(companyId) {
      switch (companyId) {
        case 14:
          return dasaLogo;
        case 16:
          return liveloLogo;
        case 18:
          return cnpLogo;
        case 19:
          return comGas;
        case 21:
          return bancoMercantil;
        case 22:
          return senaiLogo;
        case 23:
          return sesiLogo;
        case 24:
          return rexonLogo;
        default:
          return lorniLogo;
      }
    }

    function _socketConnect() {
      store.state.socket.connection
        .start({
          transport: [
            HttpTransportType.WebSockets,
            HttpTransportType.LongPolling,
            HttpTransportType.ServerSentEvents,
          ],
        })
        .then(() => {
          console.log("Connected!");
          _loadChats();
          _listingNewMessages();
        })
        .catch((e) => console.log("Connection failed: ", e));
    }

    function _changeTitleOfPage(title) {
      document.title = "Lorni " + title;
    }

    async function _loadChats() {
      const response = await _chatServices.getAllChats();

      const newMessages = response.data.filter(
        (chat) => chat.hasNewMessage && !chat.deleted,
      );

      if (newMessages.length != 0) {
        chat.quantity = chat.quantity + newMessages.length;
        chat.hasNewMessage = true;

        const lastMessage = newMessages.at(-1);

        store.dispatch("AddMessages", {
          conversationId: lastMessage.conversationId,
          message: lastMessage,
        });
      }
    }

    function accessChat() {
      chat.hasNewMessage = false;
      chat.quantity = 0;
    }

    watch(
      () => route.fullPath,
      (newVal, oldVal) => {
        if (newVal === "/chat") {
          accessChat();
        }
      },
    );

    onMounted(() => {
      _getMenuOptions();
      store.commit("setSocket", _socket);

      _socketConnect();
    });

    const nameUser = computed(() => {
      const { first_name, last_name, nick_name } = store.state.userdata;

      if (
        nick_name?.length === 0 ||
        nick_name == "" ||
        nick_name == null ||
        nick_name == "null"
      ) {
        return `${first_name} ${last_name}`;
      } else {
        return `${first_name} ${last_name} (${nick_name})`;
      }
    });

    return {
      //----ICONS
      Company,
      Data,

      //----CONSTANTS
      route,
      userData,
      adminMenu,
      dataMenu,
      refAudioChat,
      nameUser,

      //----VARIABLES
      menuOptions,
      showAdm,
      chat,
      analyticPermissions,
      admPermissions,

      //----FUNCTIONS
      toogleAdm,
      validateActionsPage,
      isUserMaster,
      logout,
      accessChat,
      setLogoLorni,
    };
  },
};
</script>

<style lang="scss" scoped>
.side-bar {
  background: var(--q-primary);
  height: 100%;
  /* width: 100%;   */
  /* min-height: 19vh; */
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  //justify-content: space-between;

  padding: 0 1%;

  > label {
    margin: 5% 0 3% 0;
  }

  .actions {
    display: flex;
    overflow-y: auto;
    width: 100%;
    flex-direction: row;

    > button {
      display: flex;
    }
  }

  @media (min-width: 1040px) {
    /* height: 100%; */

    .text-profile {
      display: none;
    }

    flex-direction: column;
    align-items: center;
    padding: 0 3% 3% 3%;

    .header {
      width: 100%;
    }

    .menu-list {
      display: flex;
      > div {
        width: 70%;
      }
    }

    .actions {
      display: flex;
      flex-direction: column;

      > button {
        display: none;
      }
    }
  }
}

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff23;
  padding: 0.8rem 0;
  border-radius: 0px 0px 40px 40px;
  margin-bottom: 15%;
}

.menu-list {
  width: 100%;
  /* height: 28%; */
  overflow: auto;
  display: none;
}

.dropdown-list {
  width: 100%;
  overflow: auto;
  display: flex;
  // background: #1a1a1a;
}

.menu-list,
.dropdown-list {
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ffffff23;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-track {
    background-color: var(--q-primary);
  }

  .item {
    display: flex;
    align-items: center;
    margin: 4px 0;

    .q-item {
      width: 100%;
      border-radius: 20px;
    }

    .avatar-menu {
      display: flex;
      align-items: center;
      justify-content: center;

      width: 24px;
      height: auto;

      margin-right: 16px;
    }
  }
}
</style>
